import React from 'react';
import { FaEdit, FaTrash, FaUniversity } from 'react-icons/fa';

const ClubsTable = ({ clubs, onEdit, onDelete, showSubDistrict = false }) => {
    return (
        <div className="bg-white rounded-3xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.02)] overflow-hidden">
            {/* Desktop Table View */}
            <div className="hidden md:block overflow-x-auto no-scrollbar">
                <table className="w-full text-left">
                    <thead>
                        <tr className="bg-slate-50/50 border-b border-slate-50">
                            <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Organizational Unit</th>
                            {showSubDistrict && <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Sector</th>}
                            <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Tier</th>
                            <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Classification</th>
                            <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest">Mission Logs</th>
                            <th className="px-10 py-5 text-[10px] font-black text-slate-400 uppercase tracking-widest text-right">Operations</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {clubs.length === 0 ? (
                            <tr>
                                <td colSpan={showSubDistrict ? 6 : 5} className="px-10 py-12 text-center text-slate-400 font-bold uppercase tracking-widest text-[10px]">
                                    No tactical units deployed
                                </td>
                            </tr>
                        ) : (
                            clubs.map((club) => (
                                <tr key={club.lion_ID || club.id} className="hover:bg-slate-50/50 transition-colors group">
                                    <td className="px-10 py-6">
                                        <div className="flex items-center gap-4">
                                            <div className="w-10 h-10 rounded-2xl bg-slate-50 flex items-center justify-center text-slate-400 group-hover:bg-white group-hover:text-indigo-600 transition-all border border-transparent group-hover:border-slate-100 shadow-sm">
                                                <FaUniversity size={14} />
                                            </div>
                                            <span className="text-sm font-black text-slate-900 uppercase tracking-tight">{club.name}</span>
                                        </div>
                                    </td>
                                    {showSubDistrict && <td className="px-10 py-6 text-xs font-bold text-slate-500 uppercase tracking-widest">{club.sub_district_name}</td>}
                                    <td className="px-10 py-6">
                                        <span className="inline-block bg-white border border-slate-100 text-slate-900 text-[10px] px-4 py-1.5 rounded-xl font-black uppercase tracking-widest shadow-sm">
                                            {club.category}
                                        </span>
                                    </td>
                                    <td className="px-10 py-6 text-xs font-bold text-slate-400 uppercase tracking-widest">{club.type}</td>
                                    <td className="px-10 py-6">
                                        <div className="flex items-center gap-2">
                                            <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
                                            <span className="text-sm font-black text-slate-900">{club.project_count}</span>
                                        </div>
                                    </td>
                                    <td className="px-10 py-6 text-right">
                                        <div className="flex justify-end gap-3 opacity-0 group-hover:opacity-100 transition-opacity">
                                            <button
                                                onClick={() => onEdit(club)}
                                                className="w-10 h-10 rounded-xl bg-slate-50 text-indigo-600 flex items-center justify-center hover:bg-indigo-600 hover:text-white transition-all shadow-sm"
                                            >
                                                <FaEdit size={14} />
                                            </button>
                                            <button
                                                onClick={() => onDelete(club.lion_ID || club.id)}
                                                className="w-10 h-10 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center hover:bg-rose-600 hover:text-white transition-all shadow-sm"
                                            >
                                                <FaTrash size={14} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Mobile Grid View */}
            <div className="md:hidden divide-y divide-slate-50 px-6">
                {clubs.length === 0 ? (
                    <div className="py-12 text-center text-slate-400 font-bold uppercase tracking-widest text-[10px]">
                        No tactical units deployed
                    </div>
                ) : (
                    clubs.map((club) => (
                        <div key={club.lion_ID || club.id} className="py-8 space-y-4">
                            <div className="flex justify-between items-start">
                                <div>
                                    <div className="font-black text-slate-900 uppercase tracking-tight">{club.name}</div>
                                    {showSubDistrict && <div className="text-[10px] text-indigo-500 font-black uppercase tracking-widest mt-1">{club.sub_district_name}</div>}
                                    <div className="flex items-center gap-2 mt-3">
                                        <span className="bg-slate-50 border border-slate-100 text-slate-900 text-[9px] px-3 py-1 rounded-lg font-black uppercase tracking-widest">
                                            {club.category}
                                        </span>
                                        <span className="text-[9px] font-black text-slate-300 uppercase tracking-widest">
                                            {club.type}
                                        </span>
                                    </div>
                                </div>
                                <div className="bg-slate-900 px-4 py-2 rounded-2xl text-center shadow-lg shadow-slate-900/10">
                                    <div className="text-[9px] font-black text-slate-500 uppercase tracking-widest mb-0.5">Logs</div>
                                    <div className="text-lg font-black text-white tracking-tighter">{club.project_count}</div>
                                </div>
                            </div>
                            <div className="flex justify-end gap-3 pt-4">
                                <button onClick={() => onEdit(club)} className="px-6 py-3 bg-slate-50 text-slate-900 rounded-xl text-[10px] font-black uppercase tracking-widest border border-slate-100">Modify</button>
                                <button onClick={() => onDelete(club.lion_ID || club.id)} className="px-6 py-3 bg-rose-50 text-rose-600 rounded-xl text-[10px] font-black uppercase tracking-widest border border-rose-100">Erase</button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default ClubsTable;

